import requests from '@/utils/requests';

/**
 * 安装包列表接口
 * @param {*} data
 */
export function toolsPackageList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/tools/packageList',
    method: 'post',
    data
  });
}

/**
 * 安装包配置接口
 * @param {*} data
 */
export function toolsPackageSetting (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/tools/packageSetting',
    method: 'post',
    data
  });
}

/**
 * 修改安装包接口
 * @param {*} data
 */
export function packageModify (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/tools/packageModify',
    method: 'post',
    data
  });
}

/**
 * 发送安装包消息接口
 * @param {*} data
 */
export function packagePush (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/tools/packagePush',
    method: 'post',
    data
  });
}
